import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { getParameterByName } from '../../querystring.js';

const locales = {
    'pt-BR': require('../../locales/pt-BR.json'),
    'en-US': require('../../locales/en-US.json'),
    'es-ES': require('../../locales/es-ES.json')
};

class Step03 extends Component {

    constructor() {
        super();

        const querystring = getParameterByName('lang');

        const language = querystring ? querystring : navigator.language;

        const currentLocale = locales[language] ? language : 'pt-BR';

        intl.init({
            currentLocale,
            locales
        });

    }


    render() {

        return (
            <div className="step row-nps" style={{ marginTop: '10px' }}>

                <div className="text-center">
                    <h3 style={{ fontWeight: 'bold', color: '#1F140C' }}>{intl.get('steps.step03')}</h3>
                </div>
            </div>
        );

    }
}

export default Step03;